import React from 'react';
import { PRICING_CONFIG } from '../config/pricingConfig';
import { DISCLAIMERS } from '../config/disclaimers';
import { Scale, Calculator, ArrowRight, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const PricingMethodology: React.FC = () => {
  const example = PRICING_CONFIG.PRICING_TIERS[0];

  return (
    <div className="bg-[#f8fafc] min-h-screen pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 text-center">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-chui-navy/5 text-chui-navy text-[10px] font-black uppercase tracking-[0.25em] mb-8 border border-chui-navy/10">
          <Scale size={14} className="mr-2" /> Financial Transparency
        </div>
        <h1 className="text-5xl md:text-7xl font-black text-chui-navy mb-8 tracking-tighter uppercase">Pricing Methodology</h1>
        <p className="text-xl text-slate-700 max-w-2xl mx-auto font-bold leading-relaxed">How we compute your annualized cost (Representative Example).</p>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[3.5rem] shadow-2xl border border-slate-200 overflow-hidden mb-16">
          <div className="bg-[#2d334a] p-12 text-center text-white">
             <p className="text-[10px] font-black text-chui-yellow uppercase tracking-[0.4em] mb-4">Option 1: Total Scheduled Charges Annualized</p>
             <h2 className="text-6xl font-black tracking-tighter mb-2">{example.rateAnnum}</h2>
             <p className="text-sm font-black text-white/60 uppercase tracking-widest">Annualized cost (representative example)</p>
          </div>
          <div className="p-12 lg:p-16">
            <div className="grid md:grid-cols-2 gap-12 mb-16 text-left">
               <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Total Scheduled Repayment</p>
                  <p className="text-2xl font-black text-slate-900">KES {(example.totalLimit + example.subFee).toLocaleString()}</p>
               </div>
               <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Principal Received</p>
                  <p className="text-2xl font-black text-slate-900">KES {example.totalLimit.toLocaleString()}</p>
               </div>
               <div className="md:col-span-2 p-6 bg-slate-50 rounded-2xl border border-slate-100 italic">
                  <p className="text-sm font-bold text-slate-600">
                    Formula: (Total Scheduled Charges / Total Principal) × (360 / Term Days) <br/>
                    Result: (KES {example.subFee.toLocaleString()} / KES {example.totalLimit.toLocaleString()}) × (360 / 180) = {example.rateAnnum}
                  </p>
               </div>
            </div>
            <div className="pt-12 border-t border-slate-100 text-center">
               <Link to="/apply" className="bg-[#2d334a] text-white px-12 py-5 rounded-2xl font-black text-lg shadow-xl uppercase tracking-widest inline-flex items-center"><ArrowRight size={20} className="mr-4" /> Start Growth Partner Application</Link>
               <p className="mt-8 text-[10px] font-black text-slate-400 uppercase tracking-widest italic">{DISCLAIMERS.B1}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingMethodology;